export const PaymentMetadata = {
  CHECKOUT_ID: 'checkout',
  PLAN_TYPE: 'planType',
  SCOPE: 'scope',
  IMAGE: 'image',
  TOKENS: 'amt',
  REPORT_ID: 'rid',
} as const;
export type TPaymentMetadata = (typeof PaymentMetadata)[keyof typeof PaymentMetadata];
